var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({attrs:{"small":""}},'v-chip',attrs,false),on),[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v("mdi-information")]),_vm._t("default")],2)]}}],null,true)},[(_vm.infoText)?_c('span',{domProps:{"textContent":_vm._s(_vm.infoText)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }